export default function translate(propriete, i18n) {
  if (propriete.includes('lienTiersId')) return i18n.t('editionContact.lienTiers');
  if (propriete.includes('utilisateur.Identifiant')) return i18n.t('validationUtilisateur.identifiant');
  if (propriete.includes('contactsTiers')) return i18n.t('editionContact.messages.errorTiersNotExiste');
  return propriete;
}
